import { render, staticRenderFns } from "./vipcarmodel.vue?vue&type=template&id=2376bfc7&"
import script from "./vipcarmodel.vue?vue&type=script&lang=js&"
export * from "./vipcarmodel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports